<template>
  <section class="event">
    <EventSubexponentReaderMessage
      v-if="
        isEventSubexponent &&
          !isEventSubexponentViewedByOrganizer &&
          !event.is_edit
      "
    />
    <EventHeader />
    <div class="event__content">
      <component :is="determineParticipant" />
    </div>
  </section>
</template>

<script>
import EventHeader from "./EventHeader.vue";
import ParticipantSelf from "@/components/ParticipantTypes/ParticipantSelf.vue";
import ParticipantCollective from "@/components/ParticipantTypes/ParticipantCollective.vue";
import ParticipantSub from "@/components/ParticipantTypes/ParticipantSub.vue";
import ParticipantOrganizerAndMedia from "@/components/ParticipantTypes/ParticipantOrganizerAndMedia.vue";
import ParticipantPartType from "@/components/ParticipantTypes/ParticipantPartType.vue";
import ParticipantSpecialProject from "@/components/ParticipantTypes/ParticipantSpecialProject.vue";
import ParticipantInstaller from "@/components/ParticipantTypes/ParticipantInstaller.vue";
import EventSubexponentReaderMessage from "@/components/Custom/EventSubexponentReaderMessage.vue";

import { mapState, mapGetters } from "vuex";

import { i18n } from "@v2/shared/config";
import { getLocaleValue } from "@/helpers/common";

export default {
  name: "EventParticipant",

  components: {
    EventHeader,
    EventSubexponentReaderMessage,
    ParticipantSelf,
    ParticipantCollective,
    ParticipantSub,
    ParticipantOrganizerAndMedia,
    ParticipantPartType,
    ParticipantSpecialProject,
    ParticipantInstaller
  },
  data() {
    return {
      templateType: {
        collective: "ParticipantCollective",
        sub: "ParticipantSub",
        installer: "ParticipantInstaller",
        self: "ParticipantSelf",
        "part-time": "ParticipantPartType",
        "organizer-and-media": "ParticipantOrganizerAndMedia",
        "special-project": "ParticipantSpecialProject"
      }
    };
  },
  computed: {
    ...mapState("event", ["event"]),

    ...mapGetters("event", [
      "isEventSubexponent",
      "isEventSubexponentViewedByOrganizer"
    ]),
    ...mapGetters("event", ["eventId", "exhibition"]),

    locale() {
      return i18n.locale;
    },
    determineParticipant() {
      return this.templateType?.[this.event.type] || "ParticipantSelf";
    }
  },
  methods: {
    getLocaleValue
  }
};
</script>

<style lang="scss">
@import "@v2/app/styles/media";

.event {
  display: flex;
  flex-direction: column;
  flex-grow: 1;

  &__content {
    flex-grow: 1;

    background: #f9f9f9;
    padding: 40px 0 56px 0;

    @include respond-down(md) {
      padding: 22px 0 32px 0;
    }

    &-container {
      display: flex;
      flex-wrap: wrap;
      justify-content: space-between;
    }

    &-card {
      border: 1px solid var(--gray-darker);
      border-radius: 2px;
      background-color: #ffffff;
      transition: box-shadow 0.5s, border-color 0.5s;

      @include respond-down(md) {
        width: 100%;
        margin-bottom: 16px;
      }

      &.scroll-hightlight {
        box-shadow: 0 0 4px 0 rgba(0, 112, 210, 0.4);
        border-color: #0070d2;
      }

      &--long {
        width: 620px;

        @include respond-down(lg) {
          width: 442px;
        }

        @include respond-down(md) {
          width: 100%;
        }
      }
    }

    &-title {
      font-size: 22px;
      font-weight: 700;
      font-style: normal;
      font-stretch: normal;
      line-height: 28px;
      letter-spacing: normal;
      color: var(--gray-dark);
      margin-top: 50px;

      width: 100%;

      @include respond-down(md) {
        margin-top: 8px;
        font-size: 16px;
      }
    }
  }
}
</style>

<style lang="scss">
.event-notifications {
  &__item {
    &-text {
      a {
        cursor: pointer;
        color: #f6931d;
      }
    }
  }
}
</style>
